import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Button } from 'reactstrap';
import { CSVLink } from "react-csv";

import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';

const Recommender = ({ labels, data, fromDate, toDate }) => {
  const [csvData, setCSVData] = useState([]);
  useEffect(() => {
    var tablePrint = [
      {
        r1: "", r2: "Rooms & Products", r3: ""
      },
      {},
      {
        r1: "Start Date :" + fromDate,
        r2: "",
        r3: "End Date :" + toDate,
      },
      {},
      {
        r1: "Name",
        r2: "Button",
        r3: "Visits"
      },
    ];
    if (data.length > 0) {
      data.map(elem => {
        tablePrint.push({
          r1: elem.name,
          r2: elem.button,
          r3: elem.visits,
        })
      });
    }
    setCSVData(tablePrint);
  }, [data]);
  return (
    <Card>
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline"><IntlMessages id="dashboards.rooms-product" /></h5>
            <span className="text-muted text-small d-block">
              <IntlMessages id="dashboards.popular-room-product" />
            </span>
          </div>
        </div>
        <div className='float-right'>
          <CSVLink data={csvData} headers={[
            { key: "r1", label: "" },
            { key: "r2", label: "" },
            { key: "r3", label: "" },
          ]} filename="rooms-products.csv">
            <Button
              color="primary"
              outline
              size="xs"
            >
              <IntlMessages id='dashboards.download' />
            </Button>
          </CSVLink>
        </div>
      </div>
      <CardBody>
        <ReactTable
          data={data}
          columns={labels}
          defaultPageSize={5}
          filterable={false}
          showPageJump={true}
          PaginationComponent={DataTablePagination}
          showPageSizeOptions={true}
          defaultSorted={[
            {
              id: 'visits',
              desc: true,
            },
          ]}
        />
      </CardBody>
    </Card>
  );
};

export default Recommender;
